export const validateRange = (value, limitDateRange) => {
    if (!value.includes('-')) return true;

    const [startStr, endStrRaw] = value.split('-').map((s) => s.trim());
    if (!startStr) return true;

    const [sd, sm, sy] = startStr.split('/');
    if (!sd || !sm || !sy) return true;

    const startDate = new Date(+sy, +sm - 1, +sd);
    if (isNaN(startDate.getTime())) return true;

    const [ed, em, ey] = endStrRaw.split('/');
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!em && !ey) return true;

    if (em && !ey) {
        const endMonth = parseInt(em, 10);
        const estimateEndDate = new Date(+sy, endMonth - 1, 31);

        const diffEst = (estimateEndDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
        if (diffEst > limitDateRange) return false;
        return true;
    }

    if (ed && em && !ey) {
        const estimateEndDate = new Date(+sy + 1, parseInt(em, 10) - 1, parseInt(ed, 10));
        const diffEst = (estimateEndDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
        if (diffEst > limitDateRange) return false;
        return true;
    }

    if (ed && em && ey) {
        const endDate = new Date(+ey, +em - 1, +ed);
        if (isNaN(endDate.getTime())) return true;
        if (endDate < startDate) return false;

        const diff = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
        if (diff > limitDateRange) return false;

        const limitAbs = new Date(today);
        limitAbs.setDate(today.getDate() + limitDateRange);
        if (startDate > limitAbs || endDate > limitAbs) return false;

        return true;
    }

    return true;
};
